import { FC } from "react"
import { useAppSelector } from "../../../app/hooks"
import { ArticleStandard } from "../../article/components/ArticleStandard"
import { useQueue } from "../../queue/hooks/useQueue"
import {
  selectQueuedArticles,
  selectSuggestedArticles,
} from "../../queue/queueSlice"
import { NothingQueuedMessage } from "../styled/NothingQueuedMessage"
import { PageHeading } from "../styled/PageHeading"

const QueuedArticles: FC = () => {
  const suggestedArticles = useAppSelector(selectSuggestedArticles)
  const queuedArticles = useAppSelector(selectQueuedArticles)

  const { updateArticleToPlayAfterQueue } = useQueue()

  return (
    <>
      <PageHeading>Queued by you</PageHeading>
      {!queuedArticles.length ? (
        <NothingQueuedMessage>Nothing has been queued</NothingQueuedMessage>
      ) : (
        queuedArticles.map(article => {
          return (
            <ArticleStandard
              key={article.queueId}
              article={article}
              updateArticleToPlayAfterQueue={updateArticleToPlayAfterQueue}
            />
          )
        })
      )}
      {!!suggestedArticles.length && (
        <>
          <PageHeading>Coming up</PageHeading>
          {suggestedArticles.map(article => {
            return (
              <ArticleStandard
                key={article.id}
                article={article}
                updateArticleToPlayAfterQueue={updateArticleToPlayAfterQueue}
                isSuggestedArticle
              />
            )
          })}
        </>
      )}
    </>
  )
}

export default QueuedArticles
